import React, { useState, useRef, useEffect } from 'react';
import {
  Col,
  Row,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Progress,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from "reactstrap"
import axios from 'axios';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { connect } from "react-redux"
import Breadcrumb from "../../components/Common/Breadcrumb"
//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"
import jsQR from "jsqr";


const QRScanner = props => {
  document.title = "Scan QR Code | My Urban farms"
  const [scanning, setScanning] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [cameraActive, setCameraActive] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const fileInputRef = useRef(null);
  const streamRef = useRef(null);
  const scanIntervalRef = useRef(null);


  const [detected, setDetected] = useState(false);


  const adminKey = sessionStorage.getItem("pk_admin_key");


  // Helper: add admin flag
  const redirectTo = (url) => {
    if (adminKey) {
      // Admin → redirect with &admin=1
      if (url.includes("?")) {
        window.location.href = url + "&admin=1";
      } else {
        window.location.href = url + "?admin=1";
      }
    } else {
      // Normal user
      window.location.href = url;
    }
  };


  const breadcrumbItems = []

  const [availableProcesses, setAvailableProcesses] = useState([
    { id: "substrate", title: "Substrate", bgColor: "#e1b290" },
    { id: "fruiting", title: "Fruiting", bgColor: "#e1b290" }
  ]);

  useEffect(() => {
    props.setBreadcrumbItems("Scan QR Code", breadcrumbItems)
  }, [])

  useEffect(() => {
    return () => {
      stopCamera();
    };
  }, []);

  const startCamera = async () => {
    try {
      setError("");
      setSuccess("");
      setUploadedImage(null);

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: "environment",
          width: { ideal: 1280 },
          height: { ideal: 720 }
        }
      });

      streamRef.current = stream;

      // NOW videoRef.current is guaranteed to exist
      videoRef.current.srcObject = stream;

      await videoRef.current.play().catch(err => console.log(err));

      setCameraActive(true);
      setScanning(true);
      startScanning();
    } catch (err) {
      setError("Camera access denied");
      console.error(err);
    }
  };




  const stopCamera = () => {
    if (scanIntervalRef.current) clearInterval(scanIntervalRef.current);

    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }

    setCameraActive(false);
    setScanning(false);
  };


  const startScanning = () => {
    scanIntervalRef.current = setInterval(() => {
      scanFrame();
    }, 50);
  };

  const scanFrame = () => {
    if (!videoRef.current || !canvasRef.current) return;

    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);

    const code = jsQR(imageData.data, canvas.width, canvas.height);

    if (code) {
      handleQRCodeDetected(code.data);
    }
  };


  const handleFileUpload = e => {
    const file = e.target.files[0];
    if (!file) return;

    stopCamera();
    setUploadedImage(null);
    setScanning(true);

    const reader = new FileReader();
    reader.onload = event => {
      const img = new Image();
      img.onload = () => {
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;

        context.drawImage(img, 0, 0);

        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, canvas.width, canvas.height);

        if (code) {
          handleQRCodeDetected(code.data);
        } else {
          setError("No QR code found in image.");
          setScanning(false);
        }
      };
      img.src = event.target.result;
      setUploadedImage(event.target.result);
    };
    reader.readAsDataURL(file);
  };


  //   const handleQRCodeDetected = (data) => {
  //     const adminKey = sessionStorage.getItem("pk_admin_key");
  //     const role = sessionStorage.getItem("role"); // <--- IMPORTANT


  //     let qrData = data.replace(/&amp;/g, "&").trim();

  // console.log('qrData',qrData)
  //     if (
  //       qrData.includes("batch_key") &&
  //       qrData.includes("bag_key") &&
  //       qrData.includes("bag_manage_key") &&
  //       qrData.includes("farm_key")
  //     ) {
  //       // const fullURL =
  //       //   `https://capdigi.tech/2025/myurbanfarms/UFAPI/redirect.php?` +
  //       //   qrData +
  //       //   `&role=${role}`;

  //       // window.location.href = fullURL;
  //       try {
  //         const qrURL = new URL(qrData);
  //         qrURL.searchParams.set("role", role);

  //         window.location.href = qrURL.toString();
  //       } catch (e) {
  //         setError("Invalid QR format");
  //       }
  //       return;
  //     }

  //     setError("Unreadable QR. Please scan clearly.");
  //   };




  const handleQRCodeDetected = async (data) => {
    const role = sessionStorage.getItem("role");

    let qrData = data.replace(/&amp;/g, "&").trim();
    console.log("qrData", qrData);

    // Check if all params exist
    if (
      qrData.includes("batch_key") &&
      qrData.includes("bag_key") &&
      qrData.includes("bag_manage_key") &&
      qrData.includes("farm_key")
    ) {
      // Extract batch_key from the query string
      const params = new URLSearchParams(qrData.split("?")[1]);
      const batchKey = params.get("batch_key");

      if (!batchKey) {
        setError("Invalid QR: Missing batch_key");
        return;
      }

      // --- Step 2: CALL API TO CHECK STATUS ---
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/getBatchStatus/batch/`, { batchKey: batchKey }
        );

        const status =
          res?.data?.message?.data?.message?.data?.status ?? null;

        console.log("Batch Status =", status);

        if (status === 0) {
          toast.error("This batch was deleted");
          setScanning(false);
          stopCamera();
          setUploadedImage(null);

          return;
        }

        // --- Check status 1 → OK ---
        if (status === 1) {
          // Proceed to redirect
          const qrURL = new URL(qrData);
          qrURL.searchParams.set("role", role);
          window.location.href = qrURL.toString();
          return;
        }

        // Any other issue
        setError("Unable to verify batch status");
        return;

      } catch (err) {
        console.error(err);
        setError("Network error verifying batch status");
        return;
      }
    }

    setError("Unreadable QR. Please scan clearly.");
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  return (
    <>
      <Breadcrumb />

      <div style={{
        minHeight: '100vh',
        // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',

      }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8 col-sm-12 p-0">
              <div style={{
                background: 'white',
                borderRadius: '6px',
                padding: '30px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
              }}>
                {/* Header */}
                <div className="text-center mb-4">
                  {/* <div style={{
                    width: '70px',
                    height: '70px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 15px'
                  }}>
                    <i className="mdi mdi-qrcode-scan" style={{ fontSize: '36px', color: 'white' }}></i>
                  </div> */}
                  <h3 style={{ fontWeight: '700', color: '#333', marginBottom: '8px' }}>Scan QR Code</h3>
                  <p style={{ color: '#888', fontSize: '14px', margin: 0 }}>Point your camera at a QR code</p>
                </div>

                {/* Alerts */}
                {error && (
                  <div>
                    {/* <div className="alert alert-danger d-flex align-items-center" role="alert" style={{ borderRadius: '12px' }}>
                    <i className="mdi mdi-alert-circle me-2" style={{ fontSize: '20px' }}></i>
                    <span style={{ fontSize: '14px' }}>{error}</span>
                  </div> */}
                  </div>

                )}

                {success && (
                  <div className="alert alert-success d-flex align-items-center" role="alert" style={{ borderRadius: '12px' }}>
                    <i className="mdi mdi-check-circle me-2" style={{ fontSize: '20px' }}></i>
                    <span style={{ fontSize: '14px' }}>{success}</span>
                  </div>
                )}

                {/* Scanner View */}
                <div style={{
                  position: 'relative',
                  width: '100%',
                  aspectRatio: '1',
                  maxWidth: '300px',
                  margin: '0 auto 25px',
                  borderRadius: '6px',
                  overflow: 'hidden',
                  background: '#000'
                }}>
                  {/* Camera Video */}
                  {!uploadedImage && (
                    <video
                      ref={videoRef}
                      autoPlay
                      playsInline
                      muted
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        position: 'relative',
                        zIndex: cameraActive ? 10 : -1,
                        opacity: cameraActive ? 1 : 0,
                        transition: 'opacity 0.3s',
                      }}
                    />
                  )}

                  {/* Uploaded Image */}
                  {uploadedImage && (
                    <div style={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#fff',
                      padding: '30px'
                    }}>
                      <img
                        src={uploadedImage}
                        alt="QR Code"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain'
                        }}
                      />
                    </div>
                  )}

                  {/* Placeholder */}
                  {!cameraActive && !uploadedImage && (
                    <div style={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: 'linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)',
                      color: '#999'
                    }}>
                      {/* Corner Frame */}
                      <div style={{
                        width: '100%',
                        height: '100%',
                        position: 'relative'
                      }}>
                        {/* Top Left Corner */}
                        <div style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '50px',
                          height: '50px',
                          borderTop: '4px solid #5b7463',
                          borderLeft: '4px solid #5b7463',
                          borderRadius: '6px 0 0 0'
                        }}></div>

                        {/* Top Right Corner */}
                        <div style={{
                          position: 'absolute',
                          top: 0,
                          right: 0,
                          width: '50px',
                          height: '50px',
                          borderTop: '4px solid #5b7463',
                          borderRight: '4px solid #5b7463',
                          borderRadius: '0 6px 0 0'
                        }}></div>

                        {/* Bottom Left Corner */}
                        <div style={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          width: '50px',
                          height: '50px',
                          borderBottom: '4px solid #5b7463',
                          borderLeft: '4px solid #5b7463',
                          borderRadius: '0 0 0 6px'
                        }}></div>

                        {/* Bottom Right Corner */}
                        <div style={{
                          position: 'absolute',
                          bottom: 0,
                          right: 0,
                          width: '50px',
                          height: '50px',
                          borderBottom: '4px solid #5b7463',
                          borderRight: '4px solid #5b7463',
                          borderRadius: '0 0 6px 0'
                        }}></div>

                        {/* Scanning Line */}
                        {scanning && (
                          <div
                            style={{
                              position: 'absolute',
                              left: 0,
                              width: '100%',
                              height: '2px',
                              background: 'linear-gradient(90deg, transparent, #5b7463 30%, #5b7463 70%, transparent)',
                              boxShadow: '0 0 20px rgba(91, 124, 250, 0.9)',
                              animation: 'scanLine 2s ease-in-out infinite'
                            }}
                          />
                        )}
                        <div style={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',

                        }}>    <div style={{
                          width: '100px',
                          height: '100px',
                          background: 'white',
                          borderRadius: '6px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginBottom: '20px',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                        }}>
                            <i className="mdi mdi-qrcode-scan" style={{ fontSize: '50px', color: '#ccc' }}></i>
                          </div>
                          <p style={{ fontSize: '16px', fontWeight: '600', color: '#666', marginBottom: '5px' }}>Ready to Scan</p>
                          <p style={{ fontSize: '13px', color: '#999', margin: 0 }}>Start camera or upload an image</p></div>

                      </div>

                    </div>
                  )}

                  {/* Scanning Overlay Frame */}
                  {(cameraActive || uploadedImage) && (
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      pointerEvents: 'none'
                    }}>
                      {/* Dark overlay with transparent center */}
                      <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        // background: 'rgba(0,0,0,0.5)',
                        clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 0, 20% 20%, 20% 80%, 80% 80%, 80% 20%, 20% 20%)'
                      }}></div>

                      {/* Corner Frame */}
                      <div style={{
                        width: '100%',
                        height: '100%',
                        position: 'relative'
                      }}>
                        {/* Top Left Corner */}
                        <div style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '50px',
                          height: '50px',
                          borderTop: '4px solid #5b7463',
                          borderLeft: '4px solid #5b7463',
                          borderRadius: '4px 0 0 0'
                        }}></div>

                        {/* Top Right Corner */}
                        <div style={{
                          position: 'absolute',
                          top: 0,
                          right: 0,
                          width: '50px',
                          height: '50px',
                          borderTop: '4px solid #5b7463',
                          borderRight: '4px solid #5b7463',
                          borderRadius: '0 4px 0 0'
                        }}></div>

                        {/* Bottom Left Corner */}
                        <div style={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          width: '50px',
                          height: '50px',
                          borderBottom: '4px solid #5b7463',
                          borderLeft: '4px solid #5b7463',
                          borderRadius: '0 0 0 4px'
                        }}></div>

                        {/* Bottom Right Corner */}
                        <div style={{
                          position: 'absolute',
                          bottom: 0,
                          right: 0,
                          width: '50px',
                          height: '50px',
                          borderBottom: '4px solid #5b7463',
                          borderRight: '4px solid #5b7463',
                          borderRadius: '0 0 4px 0'
                        }}></div>

                        {/* Scanning Line */}
                        {scanning && (
                          <div
                            style={{
                              position: 'absolute',
                              left: 0,
                              width: '100%',
                              height: '2px',
                              background: 'linear-gradient(90deg, transparent, #5b7463 30%, #5b7463 70%, transparent)',
                              boxShadow: '0 0 20px rgba(91, 124, 250, 0.9)',
                              animation: 'scanLine 2s ease-in-out infinite'
                            }}
                          />
                        )}
                      </div>

                      {/* Scanning Text */}
                      {scanning && (
                        <div style={{
                          position: 'absolute',
                          bottom: '30px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          background: '#5b7463',
                          color: 'white',
                          padding: '12px 28px',
                          borderRadius: '30px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '12px',
                          fontSize: '15px',
                          fontWeight: '600',
                          boxShadow: '0 4px 16px rgba(91, 124, 250, 0.4)'
                        }}>
                          <div className="spinner-border spinner-border-sm" role="status" style={{ width: '18px', height: '18px', borderWidth: '2px' }}>
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <span>Scanning...</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Hidden Canvas */}
                <canvas ref={canvasRef} style={{ display: 'none' }} />

                {/* Action Buttons */}
                <div className="d-grid gap-3 mb-3">
                  {!cameraActive ? (
                    <Button
                      color="primary"
                      type="button"

                      onClick={startCamera}
                      disabled={scanning}
                      className='d-flex justify-content-center align-items-center'

                    >
                      <i className="mdi mdi-camera me-2" style={{ fontSize: '22px' }}></i>
                      Start Camera
                    </Button>

                  ) : (
                    <button
                      className="btn btn-danger btn-lg"
                      onClick={stopCamera}
                      style={{
                        borderRadius: '14px',
                        padding: '16px',
                        fontWeight: '600',
                        fontSize: '16px',
                        border: 'none',
                        boxShadow: '0 4px 16px rgba(220, 53, 69, 0.3)'
                      }}
                    >
                      <i className="mdi mdi-camera-off me-2" style={{ fontSize: '22px' }}></i>
                      Stop Camera
                    </button>
                  )}

                  <Button
                    type="button"
                    color="light"
                    className="btn btn-outline-primary"
                    onClick={triggerFileInput}
                    disabled={scanning}

                  >
                    <i className="mdi mdi-folder-image me-2" style={{ fontSize: '22px' }}></i>
                    Upload from Gallery
                  </Button>

                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleFileUpload}
                    style={{ display: 'none' }}
                  />
                </div>

              </div>
            </div>
          </div>
        </div>

        <style>{`
          @keyframes scanLine {
            0% {
              top: 0;
              opacity: 0;
            }
            10% {
              opacity: 1;
            }
            90% {
              opacity: 1;
            }
            100% {
              top: 100%;
              opacity: 0;
            }
          }
          
          button:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(0,0,0,0.15) !important;
          }
          
          button:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }
            .btn:hover {
    color: var(--bs-btn-hover-color);
    background-color: #5b7463;
    border-color: var(--bs-btn-hover-border-color);
}
        `}</style>
      </div>
    </>
  );
};

export default connect(null, { setBreadcrumbItems })(QRScanner)